import './UserInfoPanel.css';
import { Button, Divider } from 'antd';
import { useContext } from 'react';
import eventBus from '@/common/services/eventBus';
import { FileCenterContext } from '@/common/components/FileCenterProvider';
import CustomEvents from '@/common/constants/customEvents';
import { formatDate, isSubscriptionAvailable } from '@/common/utils/utils';

function UserInfoPanel() {
    // 用户信息面板内容
    const { userInfo, setUserInfo, subscription } = useContext(FileCenterContext);

    const handleLogout = () => {
        // 清除登录信息
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        setUserInfo(null);
    };

    const handleOpenVipPanel = () => {
        eventBus.emit(CustomEvents.OPEN_VIP_PANEL);
    }

    const handleOpenMyOrder = () => {
        eventBus.emit(CustomEvents.OPEN_MY_ORDER_PANEL);
    }

    if (!userInfo) {
        return null;
    }

    const subAvailable = isSubscriptionAvailable(subscription);
    let subscriptionEndDate: Date | null = null;
    if (subscription) {
        subscriptionEndDate = new Date(subscription.subscription_end);
    }

    return (
        <div className="user-panel">
            <div className='user-info'>
                <img
                    src={userInfo.avatar_url}
                    alt="avatar"
                    className="user-avatar"
                />
                <span className="user-name">{userInfo.nickname}(微信)</span>
            </div>

            {subAvailable && (
                <div>
                    <div className='text-desc'>
                        会员到期时间：{formatDate(subscriptionEndDate)}
                    </div>
                    <Button
                        type="primary"
                        onClick={handleOpenVipPanel}
                        className="user-info-btn"
                    >
                        续费会员
                    </Button>
                </div>

            )}
            {!subAvailable && (
                <div>
                    <div className='text-desc'>
                        剩余免费图片处理张数: {userInfo.free_count}
                    </div>
                    <div className='text-desc'>
                        开通叮当AI助手会员，图片处理不限量
                    </div>
                    <Button
                        type="primary"
                        onClick={handleOpenVipPanel}
                        className="user-info-btn"
                    >
                        立即开通会员
                    </Button>
                </div>
            )}

            <Divider />
            <div className='user-info-btn-container'>
                <Button
                    style={{ justifyContent: 'flex-start' }}
                    type="text"
                    onClick={handleOpenMyOrder}
                    className="user-info-btn"
                >
                    我的订单
                </Button>
                <Button
                    style={{ justifyContent: 'flex-start' }}
                    type="text"
                    onClick={handleLogout}
                    className="user-info-btn"
                >
                    退出登录
                </Button>
            </div>
        </div>
    );
}

export default UserInfoPanel